import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Dialog as DialogPrimitive } from "radix-ui";
import { SidebarContent } from "@/components/Sidebar";

/** Below `lg`: a menu button that slides the sidebar in from the left. Closes on navigation and Escape. */
export function MobileNav() {
	const [open, setOpen] = useState(false);
	const { pathname } = useLocation();
	useEffect(() => setOpen(false), [pathname]);

	return (
		<DialogPrimitive.Root open={open} onOpenChange={setOpen}>
			<DialogPrimitive.Trigger asChild>
				<button className="-ml-2 flex size-10 shrink-0 items-center justify-center rounded-md hover:bg-muted lg:hidden" aria-label="Open menu">
					<Menu className="size-5" />
				</button>
			</DialogPrimitive.Trigger>
			<DialogPrimitive.Portal>
				<DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/30 data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0 lg:hidden" />
				<DialogPrimitive.Content
					className="fixed inset-y-0 left-0 z-50 flex w-64 max-w-[85vw] flex-col bg-sidebar text-sidebar-foreground shadow-xl outline-none data-open:animate-in data-open:slide-in-from-left data-closed:animate-out data-closed:slide-out-to-left lg:hidden"
					aria-describedby={undefined}
				>
					<DialogPrimitive.Title className="sr-only">Menu</DialogPrimitive.Title>
					<DialogPrimitive.Close
						className="absolute top-4 right-3 flex size-8 items-center justify-center rounded-md hover:bg-white/10"
						aria-label="Close menu"
					>
						<X className="size-4" />
					</DialogPrimitive.Close>
					<SidebarContent />
				</DialogPrimitive.Content>
			</DialogPrimitive.Portal>
		</DialogPrimitive.Root>
	);
}
